import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    const failurePage = this.data.get("page");
    if (!failurePage) return

    const navElement = this.element.querySelector("nav.pagy.nav");
    if (!navElement) return

    this.highlightFailurePage(navElement, failurePage);
  }

  highlightFailurePage(navElement, failurePage) {
    const pageLinks = navElement.querySelectorAll("a, .current");

    pageLinks.forEach((link) => {
      const linkText = link.textContent.trim();

      if (linkText === failurePage) {
        link.classList.add("failure-page");
      }
    });
  }
}
